import { createContext } from 'react';

export type ExerciseTranslationsContextValue = {
  launchModalPausedSession: {
    title: string;
    message: {
      p1: {
        restartable: string;
        nonRestartable: string;
      };
      p2: string;
    };
    buttons: {
      resume: string;
      restart: string;
      cancel: string;
    };
    highlightedItem: {
      label: string;
      resultTitle: string;
      percentage: string;
      score: string;
      assignmentPill: string;
      deadlinePill: string;
    };
    a11yLabel: string;
  };
  launchModalCompletedSession: {
    title: string;
    message: {
      restartable: string;
      nonRestartable: string;
    };
    buttons: {
      restart: string;
      cancel: string;
      review: string;
    };
    highlightedItem: {
      label: string;
      resultTitle: string;
      percentage: string;
      score: string;
    };
    a11yLabel: string;
  };
  progressionModalPausedSession: {
    title: string;
    message: string;
    buttons: {
      restart: string;
      resume: string;
      close: string;
    };
    highlightedItem: {
      label: string;
      resultTitle: string;
      percentage: string;
      score: string;
      assignmentPill: string;
      deadlinePill: string;
    };
    a11yLabel: string;
  };
  closeDialog: string;
  serviceNotAvailable: {
    title: string;
    p1: string;
    p2: string;
  };
  exerciseAnswersModal: {
    a11yLabel: string;
  };
  exerciseLoading: {
    title: string;
    p1: string;
    p2: string;
  };
  exerciseCalculating: {
    title: string;
    p1: string;
    p2: string;
  };
  activeSession: {
    a11yLabel: string;
    buttons: {
      pause: string;
    };
    alerts: {
      retryAction: {
        message: string;
        buttons: {
          retry: string;
        };
      };
    };
  };
  progressionModalCompletedSession: {
    a11yLabel: string;
    title: string;
    messages: {
      showScore: {
        perfectResult: {
          p1: string;
          p2: string;
        };
        result: {
          p1: string;
          p2: string;
        };
        adaptive: {
          p1: string;
          p2: string;
        };
      };
      adaptive: string;
      veryGood: string;
      good: string;
      bad: string;
    };
    exerciseModule: {
      insufficient: { title: string; p1: string; step1: string; step1LinkText: string; step2: string };
      sufficient: { title: string; p1: string; stepsHtml: string };
      good: { title: string; p1: string; stepsHtml: string; p2: string };
      veryGood: { title: string; p1: string; p2: string };
      perfect: { title: string; p1: string };
    };
    highlightedItem: {
      label: string;
      resultTitle: string;
      percentage: string;
      score: string;
    };
    buttons: {
      close: string;
      review: string;
      restart: string;
    };
  };
};

export const ExerciseTranslationsContext = createContext<ExerciseTranslationsContextValue>({
  launchModalPausedSession: {
    title: '',
    message: {
      p1: {
        restartable: '',
        nonRestartable: '',
      },
      p2: '',
    },
    buttons: {
      resume: '',
      restart: '',
      cancel: '',
    },
    highlightedItem: {
      label: '',
      resultTitle: '',
      percentage: '',
      score: '',
      assignmentPill: '',
      deadlinePill: '',
    },
    a11yLabel: '',
  },
  launchModalCompletedSession: {
    title: '',
    message: {
      restartable: '',
      nonRestartable: '',
    },
    buttons: {
      restart: '',
      cancel: '',
      review: '',
    },
    highlightedItem: {
      label: '',
      resultTitle: '',
      percentage: '',
      score: '',
    },
    a11yLabel: '',
  },
  progressionModalPausedSession: {
    title: '',
    message: '',
    buttons: {
      restart: '',
      resume: '',
      close: '',
    },
    highlightedItem: {
      label: '',
      resultTitle: '',
      percentage: '',
      score: '',
      assignmentPill: '',
      deadlinePill: '',
    },
    a11yLabel: '',
  },
  closeDialog: '',
  serviceNotAvailable: {
    title: '',
    p1: '',
    p2: '',
  },
  exerciseAnswersModal: {
    a11yLabel: '',
  },
  exerciseLoading: {
    title: '',
    p1: '',
    p2: '',
  },
  exerciseCalculating: {
    title: '',
    p1: '',
    p2: '',
  },
  activeSession: {
    a11yLabel: '',
    buttons: {
      pause: '',
    },
    alerts: {
      retryAction: {
        message: '',
        buttons: {
          retry: '',
        },
      },
    },
  },
  progressionModalCompletedSession: {
    a11yLabel: '',
    title: '',
    messages: {
      showScore: {
        perfectResult: {
          p1: '',
          p2: '',
        },
        result: {
          p1: '',
          p2: '',
        },
        adaptive: {
          p1: '',
          p2: '',
        },
      },
      adaptive: '',
      veryGood: '',
      good: '',
      bad: '',
    },
    exerciseModule: {
      insufficient: { title: '', p1: '', step1: '', step1LinkText: '', step2: '' },
      sufficient: { title: '', p1: '', stepsHtml: '' },
      good: { title: '', p1: '', stepsHtml: '', p2: '' },
      veryGood: { title: '', p1: '', p2: '' },
      perfect: { title: '', p1: '' },
    },
    highlightedItem: {
      label: '',
      resultTitle: '',
      percentage: '',
      score: '',
    },
    buttons: {
      close: '',
      review: '',
      restart: '',
    },
  },
});
